import { render } from "./Menu.page.vue?vue&type=template&id=de5bfb06&scoped=true&ts=true"
import script from "./Menu.page.vue?vue&type=script&lang=ts"
export * from "./Menu.page.vue?vue&type=script&lang=ts"

import "./Menu.page.vue?vue&type=style&index=0&id=de5bfb06&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de5bfb06"]])

export default __exports__